export default __webpack_public_path__ + "static/telephone-16a23838e1bbc4c73dcfe8ba6847b6d8.svg";